import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ShareRoundedIcon from '@mui/icons-material/ShareRounded'
import { Box, Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import DoctorScheduleApi from 'api/counter/doctor-schedule.api'
import ClinicApi, { BranchInterface, DentistInterface } from 'api/master/clinic.api'
import { selectMe } from 'app/slice/user.slice'
import InputSecondNewDatePicker, { PICKER_VIEWS } from 'component/Input/InputSecondNewDatePicker'
import { getNameMonthByNo } from 'constants/date-time'
import { colors } from 'constants/theme'
import _ from 'lodash'
import moment from 'moment'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getBranch, isBuddhistYear } from 'utils/app.utils'
import { createDaysForCurrentMonth, createDaysForNextMonth, createDaysForPreviousMonth } from 'utils/calendar-helper.utils'
import { isCreate, isDelete, isExport, isUpdate, isView } from 'utils/verification.utils'
import exportDoctorSchedule from './export-doctor-schedule'
/** STYLE */
const DivHeadSchedule = styled('div')(({ theme }) => ({
  padding: '1rem',
  boxShadow: `0px 3px 6px ${colors.black08}`,
  position: 'relative',
}))

const DateDisplaySelect = styled('div')(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 700,
  '& .arrow': {
    width: '30px',
    height: '30px',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'inline-block',
    '& svg': {
      height: '16px',
      verticalAlign: 'top',
      marginTop: '7px',
      '&.arrowNext': {
        transform: 'rotate(180deg)'
      }
    },
    '&:hover': {
      backgroundColor: colors.extraLightGray,
      borderRadius: '50%'
    }
  },
  '& .monthPicker': {
    cursor: 'pointer',
    padding: '0px',
    display: 'inline-block',
    '& .ant-picker ': {
      verticalAlign: 'top !important',
      padding: '0px'
    },
    '& .ant-picker-input ': {
      padding: '0.25rem',
      '&:hover': {
        backgroundColor: colors.extraLightGray,
        borderRadius: '50%'
      },
      '& input:placeholder-shown': {
        display: 'none'
      },
      '& input': {
        display: 'none'
      },
      '& .ant-picker-borderless': {
        verticalAlign: 'top'
      }
    },
    '& .ant-picker-suffix': {
      margin: '0'
    }
  }
}))

type ViewDisplayType = 'DATE' | 'WEEK' | 'MONTH' | 'OVERALL'
export interface DateInterface {
  date: number
  month: number
  year: number
}

export interface IHeadScheduleProps {
  viewDisplay: ViewDisplayType
  branchId: number
  date: DateInterface
  doctor: string
  handleViewDisplay: (display: ViewDisplayType) => void
  handleBranchId: (branchId: number) => void
  handleDate: (objDate: DateInterface) => void
  handleDoctor: (dictors: string) => void
  maDentist: number
  handleDentist: (dentistId: number) => void
  handleClickAdd: (val: any) => void
  handleClickView: (val: any) => void
  onUseCopyMonth: (yearMonth: string, dentistId: number) => void
  dataSchedule: any
  share: () => void
  onCancel: () => void
  onSave: () => void
  edit: boolean
  listTemplateDoctor: any[],
  hasDoctor: boolean
}

export function HeadSchedule(props: IHeadScheduleProps) {
  const { t, i18n } = useTranslation()
  const user = useSelector(selectMe)
  const lang = i18n?.language || 'th'
  const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isExport: isExport(),
    isView: isView()
  }

  const [userData, setUserData]: any = useState({})
  const [branches, setBranches] = useState<BranchInterface[]>([])
  const [doctors, setDoctors] = useState<DentistInterface[]>([])
  const [branchId, setBranchId] = useState(getBranch() || 1)
  const [selectDate, setSelectDate] = useState<DateInterface>(props.date)
  const [selectDoctors, setSelectDoctors] = useState<any[]>([])
  const [selectDentist, setSelectDentist] = useState<number>(0)
  const [selectTemplate, setSelectTemplate] = useState<string>('')
  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)
  const [calendarGridDayObjects, setCalendarGridDayObjects] = useState<any>([]);

  useEffect(() => props.handleDate(selectDate), [selectDate])
  useEffect(() => props.handleDoctor(selectDoctors.filter((v: any) => v > 0).join(',') || '0'), [selectDoctors])
  useEffect(() => props.handleDentist(selectDentist), [selectDentist])
  useEffect(() => setUserData(user), [user])

  useEffect(() => {
    const currentMonthDays = createDaysForCurrentMonth(selectDate.year, selectDate.month);
    const previousMonthDays = createDaysForPreviousMonth(selectDate.year, selectDate.month, currentMonthDays);
    const nextMonthDays = createDaysForNextMonth(selectDate.year, selectDate.month, currentMonthDays);
    setCalendarGridDayObjects([
      ...previousMonthDays,
      ...currentMonthDays,
      ...nextMonthDays
    ]);
  }, [selectDate]);

  const loadData = useCallback(() => {
    setSelectTemplate('')
    ClinicApi.findAllBranches().then(({ data }) => setBranches(data))
    DoctorScheduleApi.findAllDoctor({ branchId: branchId }).then(({ data }) => {
      const dentists: DentistInterface[] = data.map((d: any) => {
        return {
          dentistId: d.userId,
          dentistFullname: d.fullname
        }
      })
      let users: any[] = dentists
      const meOnly: boolean = userData?.ownSchedule === '1' ? true : false
      if (meOnly) {
        users = _.filter(dentists, (usersData: any) => Number(usersData.dentistId) === Number(usersData?.userId))
      }
      setDoctors(users)
      setSelectDoctors([...users.map((d: DentistInterface) => d.dentistId)])
    })
  }, [props.branchId, props.date])

  useEffect(() => {
    if (selectDentist !== props.maDentist) setSelectDentist(props.maDentist)
    setSelectTemplate('')
  }, [props.maDentist])

  useEffect(() => {
    loadData()
  }, [])

  useEffect(() => {
    setSelectTemplate('')
  }, [props.listTemplateDoctor])

  const handleClickPrevious = () => {
    let unit: any = 'day'
    if (props.viewDisplay === 'WEEK') unit = 'week'
    else if (props.viewDisplay === 'MONTH' || props.viewDisplay === 'OVERALL') unit = 'month'
    const dateBefore: string = moment(`${selectDate.year}-${selectDate.month}-${selectDate.date}`, 'YYYY-M-D').format('YYYY-MM-DD')
    const date: string = moment(dateBefore).subtract(1, unit).format('YYYY-MM-DD')
    const dateSlip: any = date.split('-')
    setSelectDate({ year: parseInt(dateSlip[0]), month: parseInt(dateSlip[1]), date: parseInt(dateSlip[2]) })
  }

  const handleClickNext = () => {
    let unit: any = 'day'
    if (props.viewDisplay === 'WEEK') unit = 'week'
    else if (props.viewDisplay === 'MONTH' || props.viewDisplay === 'OVERALL') unit = 'month'
    const dateBefore: string = moment(`${selectDate.year}-${selectDate.month}-${selectDate.date}`, 'YYYY-M-D').format('YYYY-MM-DD')
    const date: string = moment(dateBefore).add(1, unit).format('YYYY-MM-DD')
    const dateSlip: any = date.split('-')
    setSelectDate({ year: parseInt(dateSlip[0]), month: parseInt(dateSlip[1]), date: parseInt(dateSlip[2]) })
  }

  const handleSelectTemplate = (e: any) => {
    const val: string = e?.target?.value || ''
    if (val !== '') {
      props.onUseCopyMonth(val, selectDentist)
      setSelectTemplate(val)
    }
  }

  const getYear = (year: number) => {
    return lang === 'th' ? year + isBuddhistYear() : year
  }


  const exportExcel = async () => {
    try {
      const dataSchedule = props.dataSchedule as []
      await exportDoctorSchedule({
        calendarGridDayObjects,
        dataSchedule,
        month: selectDate.month,
        year: getYear(selectDate.year),
        off: t('CALENDAR.OFF_DUTY'),
        leave: t('CALENDAR.LEAVE')

      });
    } catch (error) {
      console.error('Error exporting to Excel:', error);
    }
  }


  return (
    <DivHeadSchedule className="head-schedule">
      <Grid container columns={24} spacing={1}>
        <Grid item xs={24} sm={24} md={4} xl={4} sx={{ display: 'flex', justifyContent: 'center', }}>
          <DateDisplaySelect sx={{ display: 'flex', alignItems: 'center' }}>
            <Box><ArrowBackIosNewIcon sx={{ height: '18px' }} onClick={handleClickPrevious} /></Box>
            <Box width={160} className="text-center">{`${props.viewDisplay === 'DATE' ? selectDate.date : ''} ${getNameMonthByNo(selectDate.month, i18n.language)} ${selectDate.year + isBuddhistYear()}`}</Box>
            <Box><ArrowForwardIosIcon sx={{ height: '18px' }} onClick={handleClickNext} className={`arrowNext`} /></Box>
            <Box>
              <InputSecondNewDatePicker
                disabledTextField
                views={PICKER_VIEWS.MONTH}
                value={moment(`${selectDate.year}-${String(selectDate.month).padStart(2, '0')}-${String(selectDate.date).padStart(2, '0')}`, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                onchange={(e) => {
                  setSelectDate({
                    ...selectDate,
                    date: moment(e)?.date() || moment()?.date(),
                    month: (moment(e)?.month()) + 1,
                    year: moment(e)?.year() || moment()?.year()
                  })
                }}
              />
            </Box>
          </DateDisplaySelect>
        </Grid>
        <Grid item xs={24} sm={12} md={5} xl={4}
          sx={{
            xs: { mt: '12px', mb: 0 }, sm: { mt: '12px', mb: '12px' }, md: { mt: '12px', mb: '12px' }, lg: { mt: '12px', mb: '12px' }, xl: { mt: '12px', mb: '12px' }
          }}>
          <SelectInput
            label={t('DOCTOR_SCHEDULE.HEADER.BRANCH')}
            value={branchId}
            onChange={e => {
              const val = e.target.value
              setBranchId(val)
              props.handleBranchId(val)
            }}
            options={branches.map(branch => ({
              name: branch.branchName,
              value: branch.branchId
            }))}
            width="100%"
          />
        </Grid>
        {props.edit ? (
          <Grid item xs={24} sm={12} md={5} xl={4} sx={{ xs: { mt: 0, mb: 0 }, sm: { mt: '12px', mb: '12px' } }}>
            <Box sx={{ position: 'relative' }}>
              <AutocompleteSelect
                labelId="doctor-schedule-edit-dentist"
                inputLabel={t('USER_DOCTOR')}
                options={[
                  { dentistId: 0, dentistFullname: t('DOCTOR_SCHEDULE.HEADER.NOT_CHOOSE') },
                  ...doctors
                ]}
                value={
                  [{ dentistId: 0, dentistFullname: t('DOCTOR_SCHEDULE.HEADER.NOT_CHOOSE') }, ...doctors]
                    .find(d => Number(d.dentistId) === Number(selectDentist)) || null
                }
                getOptionLabel={(option: any) => option?.dentistFullname || ''}
                filterOptions={(option: any) => option?.dentistFullname || ''}
                isOptionEqualToValue={(option: any, value: any) => Number(option?.dentistId) === Number(value?.dentistId)}
                onchange={(_, value) => setSelectDentist(Number(value?.dentistId || 0))}
                sxAutoComplete={{ width: '100%' }}
              />
            </Box>
          </Grid>
        ) : (
          <Grid item xs={24} sm={12} md={5} xl={4} sx={{ xs: { mt: 0, mb: 0 }, sm: { mt: '12px', mb: '12px' } }}>
            <SelectCheckBoxInput
              label={t('USER_DOCTOR')}
              options={doctors.map(d => ({
                id: d.dentistId,
                name: d.dentistFullname,
              }))}
              selected={selectDoctors}
              onChange={newSelected => setSelectDoctors(newSelected)}
              fullWidth
              width="100%"
              searchable
              disabled={false}
              disabledAll={false}
            />

          </Grid>
        )}
        {props.edit && (
          <Grid item xs={24} sm={12} md={5} xl={4} sx={{ xs: { mt: 0, mb: 0 }, sm: { mt: '12px', mb: '12px' } }}>
            <SelectInput
              label={t('DOCTOR_SCHEDULE.HEADER.PROTOTYPE')}
              value={selectTemplate || ''}
              onChange={e => handleSelectTemplate(e)}
              options={
                props.listTemplateDoctor.length
                  ? props.listTemplateDoctor.map(template => ({
                    name: `${getNameMonthByNo(
                      Number(template.month),
                      i18n.language
                    )} ${Number(template.year) + isBuddhistYear()}`,
                    value: template.monthSchedule
                  }))
                  : [{ name: t('DOCTOR_SCHEDULE.HEADER.NOTFIND_PROTOTYPE'), value: '', disabled: true }]
              }
              width="100%"
            />
          </Grid>
        )}
        <Grid item xs={24} sm={12} md={props.edit ? 5 : 10} xl={props.edit ? 8 : 12}
          sx={{ display: 'flex', justifyContent: 'flex-end', textAlign: 'end', xs: { mt: 0, mb: 0 }, sm: { mt: '12px', mb: '12px' } }}>
          {props.edit ? (
            <Box sx={{ display: 'flex', gap: 1, xs: { mt: '12px' } }}>
              <MainButton
                title={t('DOCTOR_SCHEDULE.BUTTON.CANCEL')}
                type="secondary"
                variant="outlined"
                onClick={props.onCancel}
                style={{ width: '120px' }}
              />
              <MainButton
                title={t('DOCTOR_SCHEDULE.BUTTON.SAVE')}
                type="primary"
                variant="contained"
                onClick={props.onSave}
                style={{ width: '120px' }}
              />
            </Box>
          ) : (
            <>
              <Box display='flex' justifyContent='flex-end' sx={{ display: 'flex', gap: 1, xs: { mt: 0, mb: 0 }, sm: { mt: '12px', mb: '12px' } }}>
                <MainButton
                  title={t('DOCTOR_SCHEDULE.BUTTON.SHARE')}
                  type="primary"
                  variant="outlined"
                  onClick={selectDoctors.length === 1 || props.hasDoctor ? props.share : exportExcel}
                  startIcon={<ShareRoundedIcon />}
                />
                <MainButton
                  title={t('DOCTOR_SCHEDULE.BUTTON.MANAGE_SCHEDULE')}
                  type="primary"
                  variant="contained"
                  disabled={permissions.isUpdate.disabled}
                  onClick={props.handleClickAdd}
                  startIcon={<CalendarMonthIcon />}
                />
              </Box>
            </>
          )}
        </Grid>
      </Grid >
    </DivHeadSchedule >
  )
}
